import {Game} from "../Game";
import {gsap} from "gsap";
import {GameUtils} from "../utils/GameUtils";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class Lift extends PIXI.Container implements StageLayer {
    private _fences: PIXI.spine.Spine;
    private _displayContainer: PIXI.Container;
    private _levels: number[] = [0, -1, -2, -3, -4];

    constructor() {
        super();
        this.name = "LIFT";
        this.init()
    }

    public show(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this._fences.alpha = 0;
        this._fences.visible = true;
        this.visible = true;
        tl.add(() => {
            gsap.to(this._fences, {duration: 0.01, alpha: 1});
        });
        tl.add(GameUtils.createTimelineForAnimation(this._fences, 0, "lift_come", false));
        tl.add(() => {
            this._displayContainer.children[0].visible = true;
            this._displayContainer.visible = true;
        }, 0.5);
        return tl;
    }

    public updateDisplay(currentLevel?: number, direction?: number): void {
        if (currentLevel !== undefined) {
            (this._displayContainer.children[1] as PIXI.spine.Spine).state.setAnimation(0, this._levels[currentLevel] + "", false);
        }
        if (direction) {
            (this._displayContainer.children[0] as PIXI.spine.Spine).state.setAnimation(0, direction > 0 ? "arrow_down" : "arrow_up", true);
        }
    }

    public move(currentLevel: number, toLevel: number): gsap.core.Timeline {
        const liftVal = {val: currentLevel};
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._fences.autoUpdate = true;
            this._fences.state.setAnimation(0, "lift_loop", true);
            gsap.to(liftVal, {
                duration: 2 + (Math.abs(toLevel - currentLevel) - 1) * 0.5, val: toLevel, onUpdate: () => {
                    this.updateDisplay(Math.round(liftVal.val));
                }
            });
            gsap.to({}, {
                duration: 2 + (Math.abs(toLevel - currentLevel) - 1) * 0.5, onUpdate: () => {
                    if (NolimitApplication.isLandscape) {
                        this._displayContainer.position.y = 230 + this._fences.children[2].y;
                    } else {
                        this._displayContainer.position.y = -135 + this._fences.children[2].y;
                    }
                }
            })
        });
        return tl;
    }

    public stop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._fences.state.setEmptyAnimation(0, 0);
            this._fences.state.clearTracks();
            this._displayContainer.children[0].visible = false;
        });
        tl.add(GameUtils.createTimelineForAnimation(this._fences, 0, "lift_out", false));
        tl.add(() => {
            this._displayContainer.visible = false;
        }, 0.5);
        tl.add(() => {
            this.visible = false;
        })
        return tl;
    }

    onOrientationChanged() {
        this.onResize();
    }

    public onResize() {
        if (NolimitApplication.isLandscape) {
            this._displayContainer.position.set(758, 230);
            this._displayContainer.scale.set(0.4);
        } else {
            this._displayContainer.position.set(360, -135);
            this._displayContainer.scale.set(1);
        }
    }

    private init(): void {
        this._fences = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("fenesAnimation"));
        this.addChild(this._fences);
        this._fences.position.set(360);
        this._fences.state.setAnimation(0, "lift_come", false);
        this._fences.visible = false;

        this._displayContainer = new PIXI.Container();
        this._displayContainer.name = "Display";
        this.addChild(this._displayContainer);

        const directionArrow: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("liftArrow"));
        const floorNumber: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("liftFont"));
        floorNumber.position.set(directionArrow.width + (floorNumber.width * 0.5), 0);
        this._displayContainer.addChild(directionArrow, floorNumber);
        this._displayContainer.pivot.set(this._displayContainer.width * 0.5, this._displayContainer.height * 0.5);
        this._displayContainer.visible = false;
        this.onResize();
    }
}